.navigationContainer {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  flex: 1;
  /* Allow this flex container to shrink below the intrinsic min-content
     width of its descendants. Without this, wide page content (e.g. the
     Strategy KPI overview row or the Agent Miner sessions table) bubbles
     up through every flex ancestor and forces the document body to grow
     beyond the viewport, producing a horizontal scrollbar on the whole
     page rather than scrolling inside the table's own ScrollArea. */
  min-width: 0;
}

.navView {
  display: flex;
  flex-direction: column;
  flex: 0.2;
}

.mainView {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
